import {useAuth} from '@dofleini/security';
import {useKeycloak} from '@react-keycloak/web';
import {useCallback} from 'react';
import {useHistory} from 'react-router-dom';

import {useDetailsContext} from '@/contexts/DetailsContext';
import {NAME} from '@/modules/admin/containers/Profile';

export const useUserOptionClick = () => {
  const {logout} = useAuth();
  const {keycloak} = useKeycloak();
  const {push} = useHistory();
  const {openDialog: showProfile} = useDetailsContext(NAME);
  
  return useCallback(({action, link}) => {
    if (link)
      push(link);
    
    switch (action) {
      case 'PROFILE':
        showProfile();
        break;
      case 'LOGOUT':
        logout().then(() => {
          if (keycloak.authenticated)
            keycloak.logout({
              redirectUri: window.location.origin,
            });
        });
        break;
      default:
        break;
    }
  }, [keycloak, logout, push, showProfile]);
};
